import { useState, useEffect } from "react";
import { Outlet, Link, useLoaderData, NavLink } from "react-router-dom";
import Select from 'react-select'
// import "antd/dist/antd.css";
import { Table } from "antd";
import { CSVLink } from "react-csv";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import Spinner from './Spinner';

import * as API from "../services/listados";
import * as APIESPECIALISTAS from "../services/especialistas";

export async function loader() {
  // const pacientes = await API.getAllPacientes();
  // return { pacientes };
}

export function ListadoAdminTratamientos() {
  // const { pacientes } = useLoaderData();
  const [listadoFechaIniTrat, setListadoFechaIniTrat] = useState("");
  const [listadoFechaFinTrat, setListadoFechaFinTrat] = useState("");


  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Data');


  const [loading, setLoading] = useState(false);

  const [listadoResult, setListadoResult] = useState("");
  const [columns, setColumns] = useState([]);
  const [columnsExcel, setColumnsExcel] = useState([]);
  const [listadoResultSinSaltosDeLinea, setListadoResultSinSaltosDeLinea] = useState("");
  console.log(listadoResultSinSaltosDeLinea)


  const submitListado = async (e) => {
    setLoading(true);
    e.preventDefault();
    console.log(
      listadoFechaIniTrat,
      listadoFechaFinTrat
    );
    try {
      await API.getListadoTratamientos(
        listadoFechaIniTrat,
        listadoFechaFinTrat
      ).then(
        (val) => {
          setListadoResult(val);
          // window.location.replace(
          //   `../visitas-psicologicas/${val.id}`
          // );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };



  useEffect(() => {
    if (listadoResult.length > 0) {
      // Obtenemos las claves de la primera fila para usarlas como nombres de columna
      const keys = Object.keys(listadoResult[0]);
    
      const newColumns = keys.map(key => ({
        title: key,
        dataIndex: key,
        key: key,
        // width: 100
      }));
    
      setColumns(newColumns);

      const newColumnsExcel = keys.map(key => ({
        header: key,
        key: key,
        width: 15
      }));
      
      setColumnsExcel(newColumnsExcel);

      // Iteramos sobre cada objeto en el array y eliminamos los saltos de línea del campo "Observaciones"
      const arraySinSaltosDeLinea = listadoResult.map(objeto => {
        if (objeto.Observaciones !== undefined) {
          return {
            ...objeto,
            Observaciones: objeto.Observaciones.replace(/\n/g, '')
          };
        } else {
          return objeto;
        }
      });

      setListadoResultSinSaltosDeLinea(arraySinSaltosDeLinea);
    }
  }, [listadoResult]);

  // Función para exportar a Excel
  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Data');

    // Añadir las columnas al archivo Excel (asumiendo que columnsExcel es el estado que contiene las columnas)
    worksheet.columns = columnsExcel;

    // Añadir datos al archivo Excel (asumiendo que listadoResult es el estado que contiene los datos)
    listadoResult.forEach(objeto => {
      worksheet.addRow(objeto);
    });

    // Guardar el archivo Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'Listado-completo.xlsx');
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitListado}>

          <div className='grid--2col'>
           

            <div className='field'>
              <label htmlFor='listadoFechaIniTrat'>Fecha Inicio Tratamiento</label>
              <div className='control'>
                <input
                  className='input'
                  id='listadoFechaIniTrat'
                  type='date'
                  value={listadoFechaIniTrat}
                  onChange={(e) => setListadoFechaIniTrat(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='listadoFechaFinTrat'>Fecha Fin Tratamiento</label>
              <div className='control'>
                <input
                  className='input'
                  id='listadoFechaFinTrat'
                  type='date'
                  value={listadoFechaFinTrat}
                  onChange={(e) => setListadoFechaFinTrat(e.target.value)}
                />
              </div>
            </div>

           

          </div>

          {loading ? (
                <div className="spinner-container">
                    <Spinner />
                </div>
            ) : (
          listadoResult?.length ? (
          <div className="listado-tabla-container">

            {/* <Table dataSource={listadoResult} columns={columns} /> */}
            <Table
              dataSource={listadoResult.map((item, index) => ({
                ...item,
                key: index // O utiliza una propiedad única de cada elemento si la tienes
              }))}
              columns={columns}
              scroll={{ x: 'max-content' }}
            />
            <div className="btn-dwnld">
                <CSVLink
                  filename={"Listado-completo.csv"}
                  data={listadoResultSinSaltosDeLinea}
                  className="button is-link"
                  separator={"|"}
                >Descargar CSV</CSVLink>
                <button
                  className="button is-link"
                  onClick={exportToExcel}
                >
                  Descargar XLSX
                </button>
            </div>
          </div>
          ) : (
            <p>
              <i>Sin resultados</i>
            </p>
          )
        )}
        </form>
      </div>
      <div id='actions'>
        <button className='button is-link' form='formNewElement' type='submit'>
          Generar Listado
        </button>
      </div>
    </>
  );
}
